import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Buttons, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';
import { userStageSelector } from 'Store/modules/validations/selectors';
import { useTranslation } from 'Hooks/useTranslation';
import { useFetchGetUserClabe } from 'Containers/Account/components/AccountProfile/hooks';
import { useFetchGetCustomers } from 'Containers/Plans/hooks';
import DashboardClabeForm from 'Containers/Dashboard/components/TaxScreen/components/DashboardClabeForm';
import { setBodyOverflow } from 'Styles/utils/utils';
import { FRONT_PLANS, PLAN_FLEX_LITE, plansNameMapping } from 'Constants/plans';
import { stages } from 'Constants/stages';
import * as Styled from './styles';

const ConfirmClabeBanner = (): JSX.Element | null => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  const userStage = useSelector(userStageSelector);
  const { showModal, hideModal } = useContext(ModalContext);
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { isLoading, data } = useFetchGetUserClabe();
  const { data: customer } = useFetchGetCustomers(isAuthenticated);
  const plan = useMemo(
    () =>
      customer && customer.activePlan
        ? customer.activePlan.name === PLAN_FLEX_LITE
          ? FRONT_PLANS.FLEX_LITE
          : plansNameMapping(customer.activePlan.name)
        : FRONT_PLANS.BASIC,
    [customer]
  );

  const handleClick = (): void => {
    setBodyOverflow();
    showModal({
      comp: (
        <Modals.Centered maxSize="XL" hasClose onClose={hideModal}>
          <DashboardClabeForm clabeUser={data?.CLABE || data?.prefilledCLABE} />
        </Modals.Centered>
      ),
    });
  };
  const showConfirmClabeBanner = !isLoading && data?.CLABE && plan === FRONT_PLANS.FLEX;

  return showConfirmClabeBanner ? (
    <Styled.ConfirmClabeContainer align="center" testID="confirmBanner">
      <Text type="paragraphs" size="S_L_S" color="dark">
        {t(`Confirm.Clabe.Description`, {
          clabe: data?.CLABE?.slice(-4) || data?.prefilledCLABE?.slice(-4),
        })}
      </Text>
      {userStage !== stages.FINISHED_TRANSFERRING && (
        <Buttons.Classic
          size="xs"
          mode="primary"
          label={t(`Confirm.Clabe.CTA`)}
          onClick={handleClick}
        />
      )}
    </Styled.ConfirmClabeContainer>
  ) : null;
};

export default ConfirmClabeBanner;
